import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { DeferredPromise } from './deferred-promise';

// A modal ts file should inherit from this as it provides access to closeModal function, to the modalData field which represents the data it was opened with by commonService,
// and to the close promise, which commonService returns back to the component that opened the modal and might be waiting for the close event by subscribing to commonService.openModal
export class BaseModalComponent {

    modalData: any;
    options: any;
    onClose = new DeferredPromise<ModalResult>();

    constructor(
        private baseModalService: BsModalService,
        private baseModalRef: BsModalRef) {
        if (<DataModalOptions>baseModalService.config) {
            this.modalData = (baseModalService.config as DataModalOptions).modalData;
            this.options = (baseModalService.config as DataModalOptions).options;
        }
    }

    closeModal(result?: boolean, data?: any): void {
        this.baseModalRef.hide();
        this.onClose.resolve({ modalResult: result ? result : false, modalData: data ? data : null });
    }
}

// @Injectable({ providedIn: 'root' })
export class DataModalOptions extends ModalOptions {
    modalData?: any;
    options?: any;
    isDRExport?: boolean;

    constructor(private value?: Partial<DataModalOptions>) {
        super();
        this.keyboard = true;  // (true means esc key closes modal) Set this default before assigning so that it can be overwritten
        if (value) {
            Object.assign(this, value);
        }
        this.backdrop = false;
        this.animated = false;
        this.ignoreBackdropClick = true;
    }
}

export class ModalResult {
    modalResult: boolean;
    modalData: any;
}
